import {createReducer, PayloadActionCreator} from "@reduxjs/toolkit";
import {
  fetchBasicInfoByUserIdOperation,
  ALL_BASIC_INFO_UPDATE_OPERATIONS,
} from "store/operation/basicInfo";
import {signOutOperation} from "store/operation/operations";
import {nullable} from "types/basic";
import {ResidentialApplicationBasicInfoResponse} from "types/dto/residentialApplicationBasicInfoResponse";
import {BasicInfoState} from "types/basicInfo";

const initialState: BasicInfoState = null;

const isUpdateBasicInfoSuccessOps = (targetOpe: PayloadActionCreator<any>): boolean => {
  return ALL_BASIC_INFO_UPDATE_OPERATIONS.some((opt) => opt.success.type === targetOpe.type);
};

const basicInfoReducer = createReducer<nullable<ResidentialApplicationBasicInfoResponse>>(
  initialState,
  (builder) =>
    builder
      .addCase(signOutOperation.pending, () => initialState)
      .addCase(
        fetchBasicInfoByUserIdOperation.success,
        (state, {payload: basicInfoResponseDto}) => basicInfoResponseDto
      )
      .addMatcher(isUpdateBasicInfoSuccessOps, (state, {payload}) => {
        return {
          ...state,
          ...payload,
        };
      })
);

export default basicInfoReducer;
